import React from 'react'
import {
  // Accordion,
  // AccordionItem,
  // AccordionButton,
  // AccordionPanel,
  // AccordionIcon,
  Box,
  Grid,
  Heading
} from '@chakra-ui/react'
import Footer from '../../components/Footer'
import Wrap from '../../components/Wrap'
import { BlogPost, type BlogPostType } from '../../components/BlogPost'
import { usePageContext } from 'vike-react/usePageContext'
import '@fontsource/kalam'

const Page: React.FC = () => {
  const pageContext = usePageContext() as any
  const { posts } = pageContext.pageProps
  return (
    <>
      <Wrap
        pt="80px"
        bottomHR={false}
        bg="linear-gradient(0deg, #F6E05E2b 0%, rgba(255,255,255,1) 10vh)"
        sx={{
          pb: '80px'
        }}
      >
        <Heading
          as="h3"
          m="0"
          fontSize={{ base: '78px' }}
          textAlign="center"
          display="block"
          w="100%"
        >
          Blog
        </Heading>
      </Wrap>
      <Wrap bottomHR={false}>
        <Box>
          <Grid
            templateColumns={{
              base: '1fr',
              md: '1fr 1fr',
              xl: '1fr 1fr 1fr'
            }}
            gap="20px"
            mt="60px"
          >
            {posts.map((post: BlogPostType, index: number) => {
              return <BlogPost post={post} key={index} />
            })}
          </Grid>
        </Box>
      </Wrap>
      <Footer />
    </>
  )
}

export { Page }
